import React from 'react';
import { Calendar, Filter } from 'lucide-react';
import { getActiveFilterChips, getApiFetchDateLabel } from './orderTrackingFilterSummary';

export function OrderTrackingActiveFilters({
  filterState,
  lastRefreshLabel,
  loading,
  variant = 'panel',
}) {
  const apiDate = getApiFetchDateLabel(filterState);
  const chips = getActiveFilterChips(filterState).filter(
    (chip) => variant !== 'toolbar' || chip.key !== 'source'
  );

  return (
    <div className={`otd-active-filters otd-active-filters--${variant}`}>
      {variant !== 'toolbar' && (
        <div className='otd-active-filters__api-row'>
          <Calendar size={14} className='otd-active-filters__icon' />
          <span className='otd-active-filters__api-label'>{apiDate.label}:</span>
          <span className='otd-active-filters__api-value'>{apiDate.value}</span>
          {lastRefreshLabel && (
            <span className='otd-active-filters__refreshed'>
              {loading ? ' · Refreshing…' : ` · Updated ${lastRefreshLabel}`}
            </span>
          )}
        </div>
      )}

      {chips.length > 0 && (
        <div className='otd-active-filters__chips-row'>
          <Filter size={13} className='otd-active-filters__icon' />
          <span className='otd-active-filters__chips-label'>Active filters</span>
          <div className='otd-active-filters__chips'>
            {chips.map((chip) => (
              <span key={chip.key} className='otd-active-filters__chip' title={`${chip.label}: ${chip.value}`}>
                <span className='otd-active-filters__chip-key'>{chip.label}</span>
                <span className='otd-active-filters__chip-val'>{chip.value}</span>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
